import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateMapsEditor } from '../../actions/mapsEditorActions';

import MapsEditorLocationImageForm from './MapsEditorLocationImageForm';
import { MapsEditorMarkerImage } from './MapsEditorMarkerImage';

export class MapsEditorImageSettings extends Component {
  handleCheckboxChange = (name) => (event) => {
    this.props.updateMapsEditor({ [name]: event.target.checked });
  };

  handleImageChange = (locationDefaultImage) => {
    this.props.updateMapsEditor({
      location_default_image: locationDefaultImage,
    });
  };

  handleImageDisplayChange = ({ target: { value } }) => {
    this.props.updateMapsEditor({
      image_display_mode: value,
    });
  };

  renderImageDisplayOptions = () => {
    const { image_display_mode } = this.props;

    return (
      <div>
        <div className="maps-editor-label">
          Choose How To Display Your Location Images
        </div>
        <div className="maps-editor-form-group form-radio-group">
          {
            [
              {
                value: 'crop_4_3',
                label: 'Crop image to fill',
                description: 'Scales and crops your images to fill a 4:3 frame (or 16:9 if you’ve selected the 2-Column Location Image List layout). Parts that don\'t fit will be trimmed—no empty borders.'
              },
              {
                value: 'fit_container',
                label: 'Adjust the height of the image container to match image aspect ratios',
                description: 'Images fit in the location view without cropping. We recommend images slightly wider than they are tall (16:9 and 4:3 are good examples) for most use cases. Also - note that if using the multiple images per location feature, the best experience is one where all images have the same aspect ratio.'
              }
            ].map(({value, label, description}) => (
              <label className="form-radio-label" key={value}>
                <input
                  type="radio"
                  name={value}
                  value={value}
                  checked={image_display_mode === value}
                  onChange={this.handleImageDisplayChange}
                  className="form-radio-input"
                />
                <div className="form-radio-label-copy">
                  <div>{label}</div>
                  <div className="maps-editor-sublabel">{description}</div>
                </div>
              </label>
            ))
          }
        </div>
      </div>
    );
  };

  renderLocationDefaultImage = () => {
    const imageMaxFileSize = 10000000;

    return (
      <div className="pbxl">
        <div className="maps-editor-label">
          Default Location Image
          <div className="maps-editor-sublabel">
            Upload a default image to use for locations that don't have an image set. PNG (recommended), JPG and JPEG formats supported.
          </div>
        </div>
        <MapsEditorMarkerImage
          name="location_default_image"
          value={this.props.location_default_image}
          handleChange={this.handleImageChange}
          s3MarkerFormData={this.props.s3MarkerFormData}
          s3MarkerPostUrl={this.props.s3MarkerPostUrl}
          s3MarkerPostHost={this.props.s3MarkerPostHost}
          maxFileSize={imageMaxFileSize}
        />
      </div>
    );
  };

  renderCategoriesLocationImages = () => {
    const { category_location_images_enabled } = this.props;

    return (
      <div className="pbxl">
        <div className="maps-editor-label">
          Category Location Images
          <div className="maps-editor-sublabel">
            Set a default location image for each category. Location images will be displayed in the location popup when a user clicks on a location pin.
          </div>
        </div>
        <div>
          <label className="form-checkbox-label">
            <input
              type="checkbox"
              name="category_location_images_enabled"
              className="form-checkbox-input"
              checked={category_location_images_enabled}
              onChange={this.handleCheckboxChange('category_location_images_enabled')}
            />
            <div className="form-checkbox-label-copy">
              Enable category-specific location images
            </div>
          </label>
          {category_location_images_enabled && (
            <div className="maps-editor-categories-list">
              {this.renderCategoryLocationImages()}
            </div>
          )}
        </div>
      </div>
    );
  };

  renderCategoryLocationImages = () => {
    const { categories, categories_attributes } = this.props;
    if (!categories?.length) return null;

    return categories.map(({ id, name, location_image }) => (
      <MapsEditorLocationImageForm
        key={id}
        id={id}
        name={name}
        location_image={location_image}
        categories_attributes={categories_attributes}
      />
    ));
  };

  render() {
    return (
      <div className="maps-editor-form-group">
        <div className="row">
          <div className="col-md-6 prxl-md">
            {this.renderImageDisplayOptions()}
            {this.renderLocationDefaultImage()}
          </div>
          <div className="col-md-6">
            {this.renderCategoriesLocationImages()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.mapsEditor,
});

export default connect(mapStateToProps, { updateMapsEditor })(MapsEditorImageSettings);
